import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./Pages/Login/login";
import Dashboard from "./Pages/Dashboard/dashboard";
import RoleDashboard from "./Pages/Dashboard/RoleDashboard";
import MyData from "./Pages/DataManagement/MyData";
import DataExport from "./Pages/DataManagement/DataExport";
import { AuthProvider } from "./Pages/Auth/AuthContext";
import ProtectedRoute from "./Pages/ProtectedRoute";
import UserManagement from "./Pages/UserManagement/UserManagementNew";
import StaffManagementList from "./Pages/StaffManagement/StaffManagementList";
import EditStaff from "./Pages/StaffManagement/EditStaff";
import EditStaffInfo from "./Pages/StaffManagement/EditStaffInfo";
import EditJobInfo from "./Pages/StaffManagement/EditJobInfo";
import EditBenefits from "./Pages/StaffManagement/EditBenefits";
import EditWorkExperience from "./Pages/StaffManagement/EditWorkExperience";
import EditTraining from "./Pages/StaffManagement/EditTraining";
import EditSkills from "./Pages/StaffManagement/EditSkills";
import ComprehensiveStaffWizard from "./Pages/StaffManagement/ComprehensiveStaffWizard";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/signin" element={<Login />} />
            <Route path="/login" element={<Navigate to="/signin" replace />} />

            {/* Protected Routes */}
            {/* New Role-Based Dashboard - Available for all users */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* Admin Dashboard - Admin only */}
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute adminOnly={true}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* My Data - User only access */}
            <Route
              path="/my-data"
              element={
                <ProtectedRoute>
                  <MyData />
                </ProtectedRoute>
              }
            />

            {/* Data Export - All authenticated users */}
            <Route
              path="/data-export"
              element={
                <ProtectedRoute>
                  <DataExport />
                </ProtectedRoute>
              }
            />

            {/* Staff Management Routes */}
            <Route
              path="/comprehensive-staff-wizard"
              element={
                <ProtectedRoute>
                  <ComprehensiveStaffWizard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/staff-management"
              element={
                <ProtectedRoute>
                  <StaffManagementList />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId"
              element={
                <ProtectedRoute>
                  <EditStaff />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/info"
              element={
                <ProtectedRoute>
                  <EditStaffInfo />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/job"
              element={
                <ProtectedRoute>
                  <EditJobInfo />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/benefits"
              element={
                <ProtectedRoute>
                  <EditBenefits />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/work-experience"
              element={
                <ProtectedRoute>
                  <EditWorkExperience />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/training"
              element={
                <ProtectedRoute>
                  <EditTraining />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/skills"
              element={
                <ProtectedRoute>
                  <EditSkills />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/info"
              element={
                <ProtectedRoute>
                  <EditStaffInfo />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/job"
              element={
                <ProtectedRoute>
                  <EditJobInfo />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-staff/:staffId/benefits"
              element={
                <ProtectedRoute>
                  <EditBenefits />
                </ProtectedRoute>
              }
            />

            <Route
              path="/users"
              element={
                <ProtectedRoute adminOnly={true}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />

            <Route
              path="/user-management"
              element={
                <ProtectedRoute adminOnly={true}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />

            {/* Default redirect */}
            <Route path="/main" element={<Navigate to="/dashboard" replace />} />
            <Route path="/" element={<Navigate to="/signin" replace />} />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/signin" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
